<script>
import baseMixin from '@/mixins/baseMixin'
import { mapGetters } from 'vuex'
import InfoLabel from '@/components/general/info-label.vue'

export default {
  name: 'DisputeDialogClientInfoCard',
  components: { InfoLabel },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      timesheet: 'disputes/activeTimesheet',
    }),
  },
  methods: {
    isLastIndex(index) {
      return index === this.compileInfoList.length - 1
    },
  },
}
</script>

<template>
  <v-card class="rounded-lg" elevation="0">
    <v-card-text>
      <InfoLabel class="info-label__client-name">
        <template v-slot:label>
          <p class="mb-0 font-weight-medium"
            ><BaseLink
              :href="returnClientUrl(timesheet.client.id)"
              :class="isDarkMode ? 'white--text' : 'black--text'"
              :title="$t('general.link.viewClientTooltip')"
              allow-insecure
              >{{ timesheet.client.name }}</BaseLink
            ></p
          >
        </template>
        <p class="mb-0 font-weight-medium opacity-5">{{
          timesheet.client.payType
        }}</p>
      </InfoLabel>

      <InfoLabel
        :label="$t('dispute.clientInfo.clientOwnerLabel')"
        class="my-4"
      >
        <p class="mb-0 font-weight-medium">{{ timesheet.client.owner.name }}</p>
      </InfoLabel>

      <InfoLabel :label="$t('dispute.clientInfo.clientTypeLabel')">
        <p class="mb-0 font-weight-medium">{{ timesheet.client.type.name }}</p>
      </InfoLabel>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" scoped>
.info-label__client-name {
  // Aligns client name link with candidate name link in the candidate info component
  margin-top: 6px !important;
}
</style>
